import React, { Component } from 'react';
import DocumentPaymentControl from './DocumentPaymentControl';
import Document404 from './Document404';
import DocumentCheckPolicy from './DocumentCheckPolicy';
import DocumentVarius from './DocumentVarius';
import DocumentAccountStatement from './DocumentAccountStatement';
import DocumentBitacoraReport from './DocumentBitacoraReport';
import DocumentContract from './Contract/DocumentContract';
import DocumentPaperLetter from './DocumentPaperLetter';
import { styles } from '../groups/GroupPrintDocuments';
import DocumentPromissoryNote from './DocumentPromissoryNote';

class DocumentView extends Component {
  constructor(props) {
    super(props);
    this.margin = this.getParamValue('no_margin');
  }

  margin = '';

  getParamValue = (paramName) => {
    var url = window.location.search.substring(1); //get rid of "?" in querystring
    var qArray = url.split('&'); //get key-value pairs
    for (var i = 0; i < qArray.length; i++) {
      var pArr = qArray[i].split('='); //split key and value
      if (pArr[0] === paramName) return pArr[1]; //return value
    }
  };

  setDocument = () => {
    const isGroup = this.getParamValue('isGroup');

    let theComponent;
    switch (this.props.match.params.document_type) {
      case 'control-pagos':
        theComponent = <DocumentPaymentControl />;
        break;
      // nuevo 2025
      case 'pagare':
        theComponent = (
          <DocumentPaperLetter
            style={
              isGroup === 'true'
                ? styles.paddingPromissoryNoteGrupal
                : styles.paddingPromissoryNoteIndividual
            }
          >
            <DocumentPromissoryNote />
          </DocumentPaperLetter>
        );
        break;
      case 'poliza':
        theComponent = <DocumentCheckPolicy />;
        break;
      case 'contrato_credito':
        theComponent = (
          <DocumentPaperLetter style={styles.containerContract}>
            <DocumentContract />
          </DocumentPaperLetter>
        );
        break;
      case 'varios':
        theComponent = <DocumentVarius />;
        break;
      case 'estado-cuenta':
        theComponent = <DocumentAccountStatement />;
        break;
      case 'bitacora-reporte':
        theComponent = <DocumentBitacoraReport />;
        break;
      default:
        theComponent = <Document404 />;
        break;
    }
    return theComponent;
  };

  render() {
    return (
      <div
        style={this.margin === true ? {} : { backgroundColor: '#F1F1F1' }}
        className="d-flex align-items-center justify-content-center"
      >
        {this.setDocument()}
      </div>
    );
  }
}

export default DocumentView;
